import { render, staticRenderFns } from "./LogoDropdown.vue?vue&type=template&id=2c8bdaae&scoped=true"
import script from "./LogoDropdown.vue?vue&type=script&lang=js"
export * from "./LogoDropdown.vue?vue&type=script&lang=js"
import style0 from "./LogoDropdown.vue?vue&type=style&index=0&id=2c8bdaae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8bdaae",
  null
  
)

export default component.exports